import api from "@/api/resultPromise.js";

const baseURL = `/api/ors/register-nat/v1`;
export default {
    get: async (path) => {
        return await api.get(`${baseURL}${path}`);
    }
}